// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post çağrılarına bağlanacak.
let mockApplications = [
    {
        id: 1,
        ad_id: 1,
        student_number: "20201234",
        name: "Ayşe",
        surname: "Yılmaz",
        faculty_code: null,
        department_code: null,
        department_name: "İşletme",
        class: 3,
        gno: 3.25,
        cv_file_name: "Ayse_Yilmaz_CV.pdf",
        telephone: "5537984244",
        email: "ayse.yilmaz@bahcesehir.edu.tr",
        status: "in_review",
        rejection_reason: null,
        work_start_date: null,
        work_end_date: null,
        documents: [
            {code: "ek1", label: "Ek 1", status: "accepted", file_name: null},
            {code: "ek2", label: "Ek 2", status: "accepted", file_name: null},
            {code: "ek3", label: "Ek 3", status: "accepted", file_name: null}
        ]
    }
];

const getAll = async (adId, config) => {
    const filter = config?.params?.filter ?? {};
    let rows = mockApplications.filter((row) => String(row.ad_id) === String(adId));

    if (filter.faculty_code) {
        rows = rows.filter((row) => row.faculty_code === filter.faculty_code);
    }
    if (filter.department_code) {
        rows = rows.filter((row) => row.department_code === filter.department_code);
    }
    if (filter.student_number) {
        rows = rows.filter((row) => row.student_number.includes(filter.student_number));
    }
    if (filter.class) {
        rows = rows.filter((row) => row.class === filter.class);
    }
    if (filter.status) {
        rows = rows.filter((row) => row.status === filter.status);
    }
    if (filter.gno_min) {
        rows = rows.filter((row) => row.gno >= Number(filter.gno_min));
    }
    if (filter.gno_max) {
        rows = rows.filter((row) => row.gno <= Number(filter.gno_max));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const updateStatus = async (id, payload) => {
    const row = mockApplications.find((item) => item.id === Number(id));
    if (row) {
        row.status = payload.status;
        row.rejection_reason = payload.description ?? null;
        row.work_start_date = payload.work_start_date ?? null;
        row.work_end_date = payload.work_end_date ?? null;
    }
    return Promise.resolve({
        data: {
            data: row ?? null,
            message: "coop_application_status_updated_success"
        }
    });
};

const updateDocumentStatus = async (id, documents) => {
    const row = mockApplications.find((item) => item.id === Number(id));
    if (row) {
        row.documents = documents;
    }
    return Promise.resolve({
        data: {
            data: row ?? null,
            message: "coop_documents_saved_success"
        }
    });
};

const remove = async (id) => {
    mockApplications = mockApplications.filter((item) => item.id !== Number(id));
    return Promise.resolve({
        data: {
            message: "successfully_deleted"
        }
    });
};

export default {
    getAll,
    updateStatus,
    updateDocumentStatus,
    remove
}
